// Currency: display everything in Indian Rupees (INR).
// Stored numeric values remain as-is (host now enters prices in INR going forward).
export const CURRENCY_SYMBOL = "\u20B9"; // ₹

export function money(amount) {
  const n = Number(amount);
  if (!isFinite(n)) return `${CURRENCY_SYMBOL}0`;
  // Use Indian numbering (1,00,000 style) with no fractional part.
  return `${CURRENCY_SYMBOL}${Math.round(n).toLocaleString("en-IN")}`;
}
